<template>
  <div style="height: 100vh; width: 100%">
    <v-col cols="12" class="pb-2">
      <v-card-title class="h6 pa-0 mb-4">
        <v-btn class="mr-2" small fab color="white" @click="$emit('return')">
          <v-icon color="black">mdi-chevron-left</v-icon>
        </v-btn>
        Deine Splits
      </v-card-title>
      <div class="button-switcher">
        <v-btn-toggle v-model="selectedSplit" mandatory class="custom-toggle">
          <div class="button-container">
            <v-btn
              :value="index"
              :ripple="false"
              v-for="(item, index) in form.splits.workouts.map((w) => w.title)"
              :key="item + index"
              class="custom-btn rounded-lg mr-2">
              <span :class="{ 'custom-toggle--active': index === selectedSplit }">
                {{ item }}
              </span>
            </v-btn>
            <div class="new-split-wrapper mr-2 ma-auto" :class="{ active: addNewSplit }">
              <v-btn v-if="!addNewSplit" style="border: 3px solid white; background: transparent" class="rounded-lg" @click.stop="startNewSplit">
                <v-icon color="white">mdi-plus</v-icon>
              </v-btn>
              <div v-else class="add-split-input-container">
                <v-text-field
                  v-model="newSplitName"
                  dense
                  outlined
                  hide-details
                  placeholder="Neuer Split"
                  ref="newSplitInput"
                  @keyup.enter="saveNewSplit"></v-text-field>
                <v-btn small icon @click="saveNewSplit"><v-icon>mdi-check</v-icon></v-btn>
                <v-btn small icon @click="cancelNewSplit"><v-icon>mdi-close</v-icon></v-btn>
              </div>
            </div>
          </div>
          <span ref="highlight" class="highlight"></span>
        </v-btn-toggle>
      </div>
    </v-col>
    <v-col class="pt-2" cols="12" style="background: #313131; height: calc(100vh - 120px)">
      <v-window touchless v-model="selectedSplit">
        <v-window-item :key="'window-' + key" v-for="(item, key) in form.splits.workouts" :value="key">
          <div v-if="selectedSplit === key" style="height: 100%">
            <v-row no-gutters style="height: 100%" v-if="!$vuetify.breakpoint.smAndDown">
              <v-col cols="6" class="pr-md-4 d-flex flex-column">
                <v-card-title class="pa-0 mt-2 mb-2">Verfügbare Übungen</v-card-title>
                <div class="filter-section mb-3">
                  <v-text-field
                    filled
                    rounded
                    dense
                    clearable
                    label="Übung suchen..."
                    v-model="exerciseSearchInput"
                    hide-details
                    class="mr-2"></v-text-field>
                  <v-menu offset-y :close-on-content-click="false" max-height="400">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="grey darken-2" v-bind="attrs" v-on="on">
                        <v-icon left>mdi-filter-variant</v-icon> Filter
                        <v-badge v-if="selectedTags.length > 0" color="primary" :content="selectedTags.length" inline class="ml-2"></v-badge>
                      </v-btn>
                    </template>
                    <v-card class="glass-card pa-3" dark width="350">
                      <v-text-field v-model="tagSearch" label="Filter suchen..." dense outlined hide-details class="mb-3"></v-text-field>
                      <v-chip-group dark v-model="selectedTags" column multiple active-class="primary--text">
                        <v-chip v-for="tag in filteredTags" :value="tag" :key="tag" filter outlined>{{ tag }}</v-chip>
                      </v-chip-group>
                    </v-card>
                  </v-menu>
                </div>
                <div class="source-list-container px-0" ref="sourceListContainer" @scroll.passive="handleScroll">
                  <div :style="{ height: `${paddingTop}px` }"></div>
                  <draggable
                    @start="isDragging = true"
                    @end="isDragging = false"
                    v-model="visibleExercises"
                    :group="{ name: 'exercises', pull: 'clone', put: false }"
                    :sort="false"
                    handle=".drag-handle"
                    :force-fallback="true"
                    :fallback-on-body="true"
                    ghost-class="ghost-card"
                    chosen-class="card-is-chosen"
                    fallback-class="moving-card-clone"
                    class="exercise-source-list">
                    <div v-for="exercise in visibleExercises" :key="exercise._id" class="source-card-wrapper">
                      <v-card class="glass-card exercise-card-source elevation-4">
                        <div class="d-flex align-center pa-2">
                          <v-img
                            :src="getImageForExercise(exercise)"
                            style="max-width: 76px"
                            class="rounded-lg"
                            height="76px"
                            width="76px"
                            cover
                            position="top center" />
                          <div class="exercise-content">
                            <div class="font-weight-bold white--text text-subtitle-1">{{ exercise.title }}</div>
                            <div class="grey--text text--lighten-1 text-caption">{{ exercise.deviceShortForm || "Allgemein" }}</div>
                          </div>
                          <div class="d-flex flex-row align-center">
                            <v-btn icon class="drag-handle" x-large style="cursor: grab"><v-icon>mdi-drag</v-icon></v-btn>
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </draggable>
                  <div :style="{ height: `${paddingBottom}px` }"></div>
                </div>
              </v-col>

              <v-col cols="6" class="pl-md-4 d-flex flex-column">
                <div class="d-flex align-center">
                  <v-card-title class="pa-0 mt-2 mb-2">Dein Workout</v-card-title>
                  <v-btn v-if="selectedForSuperset.length >= 2" color="orange" class="ml-4" small @click="createSupersetFromSelection">
                    <v-icon left>mdi-arrow-collapse-all</v-icon>
                    Kombinieren
                  </v-btn>
                </div>
                <div class="dropzone-wrapper" :class="{ 'is-dragging-active': isDragging }">
                  <draggable
                    @start="isDragging = true"
                    @end="isDragging = false"
                    v-model="item.exercises"
                    @add="onAdd"
                    group="exercises"
                    handle=".drag-handle"
                    animation="300"
                    :force-fallback="true"
                    :fallback-on-body="true"
                    ghost-class="ghost-card"
                    chosen-class="card-is-chosen"
                    fallback-class="moving-card-clone"
                    class="dropzone">
                    <div v-for="(exercise, index) in item.exercises" :key="exercise.supersetId || exercise.instanceId || exercise._id">
                      <v-card
                        v-if="!exercise.isSuperset"
                        class="glass-card exercise-card-dest elevation-6"
                        :class="{ 'is-selected-for-superset': isSelectedForSuperset(exercise) }">
                        <div class="d-flex align-center pa-2">
                          <v-img
                            :src="getImageForExercise(exercise)"
                            style="max-width: 76px"
                            height="76"
                            width="76"
                            class="exercise-avatar flex-shrink-0"
                            cover />
                          <div class="exercise-content">
                            <div class="font-weight-bold white--text">
                              {{ exercise.title }}
                              <v-chip
                                small
                                class="rounded ml-2"
                                outlined
                                :color="intensityTechniqueMapping[exercise.method].color"
                                v-if="exercise.method">
                                <v-icon small class="mr-2">{{ intensityTechniqueMapping[exercise.method].icon }}</v-icon>
                                {{ intensityTechniqueMapping[exercise.method].descriptionShort }}
                              </v-chip>
                            </div>
                            <div v-if="exercise.title === 'Senso Pro' && exercise.isConfigured" class="green--text text--lighten-1 mt-1 text-caption">
                              <v-icon small color="green" class="mr-1">mdi-check-circle</v-icon>
                              Geräteeinstellungen gespeichert
                            </div>
                            <div v-else-if="isDurationExercise(exercise)" class="mt-1">
                              <v-chip outlined small class="mr-1 mb-1">
                                <v-icon left small>mdi-clock-outline</v-icon>
                                {{ getDurationFromExercise(exercise) }} sek
                              </v-chip>
                            </div>
                            <div v-else-if="exercise.sets && exercise.sets.length > 0" class="mt-1">
                              <v-chip outlined small class="mr-1 mb-1"
                                >{{ exercise.sets.length }} {{ exercise.sets.length > 1 ? "Sätze" : "Satz" }}</v-chip
                              >
                              <v-chip
                                outlined
                                small
                                class="mr-1 mb-1"
                                v-if="exercise.weightSum && (exercise.weightSum.min || exercise.weightSum.max)">
                                <v-icon small left>mdi-weight-kilogram</v-icon>
                                {{
                                  exercise.weightSum.min === exercise.weightSum.max
                                    ? exercise.weightSum.min
                                    : `${exercise.weightSum.min} - ${exercise.weightSum.max}`
                                }}
                                kg
                              </v-chip>
                              <v-chip outlined small class="mr-1 mb-1" v-if="exercise.repSum && (exercise.repSum.min || exercise.repSum.max)">
                                <v-icon left small>mdi-repeat</v-icon>
                                {{
                                  exercise.repSum.min === exercise.repSum.max
                                    ? exercise.repSum.min
                                    : `${exercise.repSum.min} - ${exercise.repSum.max}`
                                }}
                                Wdh.
                              </v-chip>
                            </div>
                            <div v-else-if="exercise.warmup" class="orange--text mt-1 text-caption">Aufwärmsatz hinterlegt</div>
                            <div v-else class="red--text mt-1 text-caption">Noch keine Sätze hinterlegt</div>
                          </div>
                          <div class="d-flex flex-row justify-space-around align-center pa-2">
                            <v-btn
                              large
                              icon
                              @click.stop="toggleSupersetSelection(exercise)"
                              :color="isSelectedForSuperset(exercise) ? 'orange' : ''">
                              <v-icon>mdi-vector-combine</v-icon>
                            </v-btn>
                            <v-btn large icon @click="edit(exercise, index)"><v-icon>mdi-pencil</v-icon></v-btn>
                            <v-btn large icon class="drag-handle" style="cursor: grab"><v-icon>mdi-drag</v-icon></v-btn>
                            <!--
                              <v-btn icon small @click="removeExercise(index)"><v-icon color="red">mdi-delete</v-icon></v-btn>
                              -->
                          </div>
                        </div>
                      </v-card>

                      <v-card v-else class="glass-card superset-card-dest elevation-6">
                        <div class="d-flex align-center">
                          <div class="exercise-content">
                            <div v-for="subEx in exercise.exercises" :key="subEx._id" class="d-flex align-center px-2 pt-2">
                              <v-img
                                style="max-width: 40px"
                                :src="getImageForExercise(subEx)"
                                height="40"
                                width="40"
                                class="exercise-avatar flex-shrink-0 rounded"
                                cover />
                              <span class="white--text ml-3">{{ subEx.title }}</span>
                            </div>

                            <div class="pa-2 pt-1">
                              <v-divider class="mb-2"></v-divider>
                              <div v-if="exercise.exercises[0].sets && exercise.exercises[0].sets.length > 0">
                                <v-chip outlined small>
                                  <v-icon left small>mdi-format-list-numbered</v-icon>
                                  {{ exercise.exercises[0].sets.length }} {{ exercise.exercises[0].sets.length > 1 ? "Sätze" : "Satz" }}
                                </v-chip>
                              </div>
                              <div v-else class="red--text text-caption">Noch keine Sätze konfiguriert</div>
                            </div>
                          </div>
                          <div class="d-flex flex-column justify-space-around align-center pa-2">
                            <v-btn icon small @click="edit(exercise, index)"><v-icon>mdi-pencil</v-icon></v-btn>
                            <v-btn icon small class="drag-handle" style="cursor: grab"><v-icon>mdi-drag</v-icon></v-btn>
                            <v-btn icon small @click="removeExercise(index)"><v-icon color="red">mdi-delete</v-icon></v-btn>
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </draggable>
                  <div v-if="!item.exercises.length" class="empty-dropzone-text py-7">
                    <v-icon large class="mb-2">mdi-arrow-left-bold-box-outline</v-icon><br />
                    Ziehe Übungen hierher
                  </div>
                  <div class="delete-zone-wrapper">
                    <v-slide-y-reverse-transition>
                      <div v-if="isDragging" class="delete-zone">
                        <draggable group="exercises" @add="onDropInDeleteZone" class="delete-drop-area">
                          <div class="delete-content">
                            <v-icon large color="white">mdi-trash-can-outline</v-icon>
                            <span class="white--text font-weight-bold mt-2">Zum Löschen hierher ziehen</span>
                          </div>
                        </draggable>
                      </div>
                    </v-slide-y-reverse-transition>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div v-else class="d-flex flex-column" style="height: 100%">
              <div class="d-flex align-center">
                <v-card-title class="pa-0 mt-2 mb-2">Dein Workout</v-card-title>
                <v-btn v-if="selectedForSuperset.length >= 2" color="orange" class="ml-4" small @click="createSupersetFromSelection">
                  <v-icon left>mdi-arrow-collapse-all</v-icon>
                  Kombinieren
                </v-btn>
              </div>
              <div class="dropzone-wrapper">
                <draggable
                  v-model="item.exercises"
                  @add="onAdd"
                  group="exercises"
                  handle=".drag-handle"
                  animation="300"
                  :force-fallback="true"
                  :fallback-on-body="true"
                  ghost-class="ghost-card"
                  chosen-class="card-is-chosen"
                  fallback-class="moving-card-clone"
                  class="dropzone">
                  <div v-for="(exercise, index) in item.exercises" :key="exercise.supersetId || exercise._id">
                    <v-card
                      v-if="!exercise.isSuperset"
                      class="glass-card exercise-card-dest elevation-6"
                      :class="{ 'is-selected-for-superset': isSelectedForSuperset(exercise) }">
                      <div class="d-flex align-center pa-2">
                        <v-img
                          :src="getImageForExercise(exercise)"
                          style="max-width: 76px"
                          height="76"
                          width="76"
                          position="top center"
                          class="exercise-avatar flex-shrink-0"
                          cover />
                        <div class="exercise-content">
                          <div class="font-weight-bold white--text">{{ exercise.title }}</div>
                        </div>
                        <div class="d-flex flex-column justify-space-around align-center pa-2">
                          <v-btn icon small @click.stop="toggleSupersetSelection(exercise)" :color="isSelectedForSuperset(exercise) ? 'orange' : ''">
                            <v-icon>mdi-vector-combine</v-icon>
                          </v-btn>
                          <v-btn icon small @click="edit(exercise, index)"><v-icon>mdi-pencil</v-icon></v-btn>
                          <v-btn icon small @click="removeExercise(index)"><v-icon color="red">mdi-delete</v-icon></v-btn>
                        </div>
                      </div>
                    </v-card>
                    <v-card v-else class="glass-card superset-card-dest elevation-6">
                      <div class="d-flex align-center">
                        <div class="exercise-content">
                          <div v-for="subEx in exercise.exercises" :key="subEx._id" class="d-flex align-center pa-2">
                            <v-img :src="getImageForExercise(subEx)" height="40" width="40" class="exercise-avatar flex-shrink-0 rounded" cover />
                            <span class="white--text ml-3">{{ subEx.title }}</span>
                          </div>
                        </div>
                        <div class="d-flex flex-column justify-space-around align-center pa-2">
                          <v-btn icon small @click="edit(exercise, index)"><v-icon>mdi-pencil</v-icon></v-btn>
                          <v-btn icon small @click="removeExercise(index)"><v-icon color="red">mdi-delete</v-icon></v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </draggable>
                <div v-if="!item.exercises.length" class="empty-dropzone-text py-7">Füge deine erste Übung hinzu</div>
              </div>

              <v-btn fab color="primary" bottom right fixed large @click="addExerciseDialogVisible = true">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </v-window-item>
      </v-window>
      <v-btn
        color="primary"
        style="position: absolute; left: 50%; bottom: 16px; transform: translateX(-50%); box-shadow: 0 0 15px rgba(0, 150, 63, 0.7) !important"
        x-large
        rounded
        @click="nextStep()"
        >Weiter</v-btn
      >
    </v-col>

    <v-dialog v-model="addExerciseDialogVisible" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card style="background: #1e1e1e">
        <v-toolbar dark style="border-bottom-right-radius: 25px; border-bottom-left-radius: 25px">
          <v-btn icon dark @click="addExerciseDialogVisible = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Übung auswählen</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <div class="d-flex flex-column" style="height: calc(100vh - 88px)">
            <div class="filter-section mb-3">
              <v-text-field
                filled
                rounded
                dense
                clearable
                dark
                label="Übung suchen..."
                v-model="exerciseSearchInput"
                hide-details
                class="mr-2"></v-text-field>
              <v-menu offset-y :close-on-content-click="false" max-height="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="grey darken-2 white--text" v-bind="attrs" v-on="on">
                    <v-icon left>mdi-filter-variant</v-icon> Filter
                    <v-badge v-if="selectedTags.length > 0" color="primary" :content="selectedTags.length" inline class="ml-2"></v-badge>
                  </v-btn>
                </template>
                <v-card class="glass-card pa-3" dark width="350">
                  <v-text-field v-model="tagSearch" label="Filter suchen..." dense outlined hide-details class="mb-3"></v-text-field>
                  <v-chip-group dark v-model="selectedTags" column multiple active-class="primary--text">
                    <v-chip v-for="tag in filteredTags" :value="tag" :key="tag" filter outlined>{{ tag }}</v-chip>
                  </v-chip-group>
                </v-card>
              </v-menu>
            </div>
            <div class="source-list-container" @scroll.passive="handleScroll">
              <div :style="{ height: `${paddingTop}px` }"></div>
              <div v-for="exercise in visibleExercises" :key="exercise._id" class="source-card-wrapper">
                <v-card class="glass-card exercise-card-source elevation-4">
                  <div class="d-flex align-center pa-2">
                    <v-img
                      :src="getImageForExercise(exercise)"
                      style="max-width: 76px"
                      class="rounded-lg"
                      height="76px"
                      width="76px"
                      cover
                      position="top center" />
                    <div class="exercise-content">
                      <div class="font-weight-bold white--text text-subtitle-1">{{ exercise.title }}</div>
                      <div class="grey--text text--lighten-1 text-caption">{{ exercise.deviceShortForm || "Allgemein" }}</div>
                    </div>
                    <div class="d-flex flex-row align-center">
                      <v-btn icon color="primary" x-large @click="addExerciseToWorkout(exercise)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                    </div>
                  </div>
                </v-card>
              </div>
              <div :style="{ height: `${paddingBottom}px` }"></div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editMode" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
      <v-card dark v-if="selectedExercise" style="background: #3e3e3e">
        <v-card-text class="px-4 pt-2 pb-0" style="overflow-y: auto; height: 100vh; overflow-x: hidden">
          <workout-split-edit-exercise-single
            v-if="!selectedExercise.isSuperset"
            :exercise-prop="selectedExercise"
            @savedExercise="saveExercise"
            @cancel-edit="cancelEdit" />

          <workout-split-edit-exercise-multi
            v-else-if="selectedExercise.isSuperset"
            :exercises-prop="selectedExercise.exercises"
            @savedExercise="saveExercise"
            @cancel-edit="cancelEdit" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import api from "@/api"
import { mapActions, mapGetters } from "vuex"
import WorkoutSplitEditExerciseSingle from "./WorkoutSplitEditExerciseSingle.vue"
import WorkoutSplitEditExerciseMulti from "./WorkoutSplitEditExerciseMulti.vue"
import { intensityTechniqueMapping } from "./v2/utils/intensityTechniques"

export default {
  name: "WorkoutBuilderComplete",
  components: {
    draggable,
    WorkoutSplitEditExerciseSingle,
    WorkoutSplitEditExerciseMulti,
  },
  props: {
    form: { type: Object, required: true },
  },
  data() {
    return {
      isDragging: false,

      // Status & UI
      selectedForSuperset: [],
      intensityTechniqueMapping: intensityTechniqueMapping,
      addExerciseDialogVisible: false,
      addNewSplit: false,
      newSplitName: "",
      selectedSplit: 0,
      editMode: false,
      selectedExercise: null,
      selectedExerciseIndex: null,

      // Filter & Suche
      exerciseSearchInput: "",
      exerciseSearch: "",
      tagSearch: "",
      searchDebounce: null,
      selectedTags: [],
      tags: [],
      isUpdatingScroll: false,
      // Daten
      exercises: [],
      studio_id: null,

      // Virtuelle Liste
      visibleExercises: [],
      paddingTop: 0,
      paddingBottom: 0,
      itemHeight: 92,
      viewPortItemCount: 15,
    }
  },
  computed: {
    ...mapGetters("deviceStore", ["exerciseList"]),

    filteredTags() {
      if (!this.tagSearch) return this.tags
      return this.tags.filter((tag) => tag.toLowerCase().includes(this.tagSearch.toLowerCase()))
    },

    filteredExercises() {
      if (!this.exercises) return []
      if (!this.exerciseSearch && this.selectedTags.length === 0) return this.exercises
      const searchLower = this.exerciseSearch ? this.exerciseSearch.toLowerCase() : ""

      return this.exercises.filter((exercise) => {
        if (exercise.deleted) return false
        if (this.studio_id && !exercise.studios.includes(this.studio_id.toString())) return false
        const matchesTags = this.selectedTags.length === 0 || (exercise.tags && exercise.tags.some((tag) => this.selectedTags.includes(tag.name)))
        if (!matchesTags) return false
        if (searchLower === "") return true
        return (
          exercise.title.toLowerCase().includes(searchLower) ||
          (exercise.deviceShortForm && exercise.deviceShortForm.toLowerCase().includes(searchLower))
        )
      })
    },
  },
  watch: {
    exerciseSearchInput(newValue) {
      clearTimeout(this.searchDebounce)
      this.searchDebounce = setTimeout(() => {
        this.exerciseSearch = newValue
      }, 300)
    },
    filteredExercises() {
      this.updateVisibleItems()
      const container = this.$refs.sourceListContainer
      if (container) container.scrollTop = 0
    },
    selectedSplit(newIndex) {
      this.selectedForSuperset = [] // Auswahl zurücksetzen
      this.updateHighlight(newIndex)
    },
    "form.splits.workouts.length"(newLength, oldLength) {
      if (newLength > oldLength) {
        this.$nextTick(() => {
          this.selectedSplit = newLength - 1
        })
      }
    },
  },
  async created() {
    await this.fetchExercises()
    const fetchedTags = await api.fetchExerciseTags()
    this.tags = [...new Set(fetchedTags.map((tag) => tag.name || tag).sort())]
    if (!this.studio_id) {
      let studio = null
      studio = await api.getUserStudio().catch((e) => {
        window.app.$root.$children[0].checkStudio()
      })
      this.studio_id = studio.studio._id
    }
  },
  mounted() {
    this.updateHighlight(this.selectedSplit)
  },
  methods: {
    ...mapActions("deviceStore", ["setDeviceList"]),
    onAdd(event) {
      const workoutExercises = this.form.splits.workouts[this.selectedSplit].exercises
      const newExercise = workoutExercises[event.newIndex]

      // Prüfen, ob die Übung bereits eine Instanz-ID hat (sicherheitshalber)
      if (newExercise && !newExercise.instanceId) {
        // Weise eine neue, einzigartige Instanz-ID zu
        newExercise.instanceId = this.getRandomId()

        // Stelle die Reaktivität mit $set sicher (wichtig für Vue 2)
        this.$set(workoutExercises, event.newIndex, newExercise)
      }
    },
    getRandomId(length = 8) {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
      let result = ""
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return result
    },
    toggleSupersetSelection(exercise) {
      if (exercise.isSuperset) return

      // Prüft jetzt auf 'instanceId' statt '_id'
      const index = this.selectedForSuperset.findIndex((ex) => ex.instanceId === exercise.instanceId)
      if (index === -1) {
        this.selectedForSuperset.push(exercise)
      } else {
        this.selectedForSuperset.splice(index, 1)
      }
    },
    isSelectedForSuperset(exercise) {
      // Prüft jetzt auf 'instanceId' statt '_id'
      console.log(this.selectedForSuperset, exercise.title, exercise.instanceId)
      return this.selectedForSuperset.some((ex) => ex.instanceId === exercise.instanceId)
    },
    createSupersetFromSelection() {
      if (this.selectedForSuperset.length < 2) return

      const newSuperset = {
        isSuperset: true,
        supersetId: this.getRandomId(),
        exercises: JSON.parse(JSON.stringify(this.selectedForSuperset)),
      }

      const workoutExercises = this.form.splits.workouts[this.selectedSplit].exercises

      // Verwendet jetzt 'instanceId' zum Abgleich
      const idsToRemove = this.selectedForSuperset.map((ex) => ex.instanceId)
      const firstIndex = workoutExercises.findIndex((ex) => ex.instanceId === idsToRemove[0])

      const remainingExercises = workoutExercises.filter((ex) => !idsToRemove.includes(ex.instanceId))

      if (firstIndex !== -1) {
        remainingExercises.splice(firstIndex, 0, newSuperset)
      } else {
        remainingExercises.push(newSuperset)
      }

      this.form.splits.workouts[this.selectedSplit].exercises = remainingExercises
      this.selectedForSuperset = []
    },
    isDurationExercise(exercise) {
      if (!exercise.sets || exercise.sets.length === 0) return false
      const firstSet = exercise.sets[0]
      const hasDuration = firstSet.some((s) => s.text === "Dauer" && s.value)
      const hasWeight = firstSet.some((s) => s.text === "Gewicht" && s.value)
      const hasReps = firstSet.some((s) => s.text.includes("Wiederholungen") && s.value)
      return hasDuration && !hasWeight && !hasReps
    },
    getDurationFromExercise(exercise) {
      if (!this.isDurationExercise(exercise)) return ""
      const durationSetting = exercise.sets[0].find((s) => s.text === "Dauer")
      return durationSetting ? durationSetting.value : ""
    },
    handleScroll(event) {
      if (this.isUpdatingScroll) {
        return
      }
      this.isUpdatingScroll = true
      window.requestAnimationFrame(() => {
        if (event.target) {
          this.updateVisibleItems(event.target.scrollTop)
        }
        this.isUpdatingScroll = false
      })
    },
    updateVisibleItems(scrollTop = 0) {
      const startIndex = Math.max(0, Math.floor(scrollTop / this.itemHeight))
      const endIndex = startIndex + this.viewPortItemCount
      this.visibleExercises = this.filteredExercises.slice(startIndex, endIndex)
      this.paddingTop = startIndex * this.itemHeight
      const remainingItemsCount = this.filteredExercises.length - (startIndex + this.visibleExercises.length)
      this.paddingBottom = Math.max(0, remainingItemsCount * this.itemHeight)
    },
    addExerciseToWorkout(exercise) {
      // Erstelle eine tiefe Kopie der Übung
      const newInstance = JSON.parse(JSON.stringify(exercise))

      // NEU: Füge eine einzigartige Instanz-ID hinzu
      newInstance.instanceId = this.getRandomId()

      this.form.splits.workouts[this.selectedSplit].exercises.push(newInstance)

      if (this.$vuetify.breakpoint.smAndDown) {
        this.addExerciseDialogVisible = false
      }
    },
    removeExercise(index, showToast = true) {
      const exerciseToRemove = this.form.splits.workouts[this.selectedSplit].exercises[index]

      // Wichtig für Undo-Funktion
      const removedItem = {
        exercise: JSON.parse(JSON.stringify(exerciseToRemove)),
        index: index,
      }

      // Übung entfernen
      this.form.splits.workouts[this.selectedSplit].exercises.splice(index, 1)

      if (showToast) {
        this.$toast.error("Übung entfernt", {
          action: {
            text: "Rückgängig",
            onClick: (e, toastObject) => {
              this.undoRemove(removedItem)
              toastObject.goAway(0)
            },
          },
          duration: 4000,
        })
      }
    },

    undoRemove(removedItem) {
      this.form.splits.workouts[this.selectedSplit].exercises.splice(removedItem.index, 0, removedItem.exercise)
      this.$toast.success("Aktion rückgängig gemacht")
    },
    onDropInDeleteZone(event) {
      // Die Übung, die gerade fallengelassen wurde
      const droppedExercise = event.item._underlying_vm_

      // Finde den ursprünglichen Index der Übung in der Workout-Liste
      const originalIndex = this.form.splits.workouts[this.selectedSplit].exercises.findIndex((ex) => {
        // Wir müssen eine eindeutige ID verwenden. instanceId ist perfekt dafür.
        return ex.instanceId === droppedExercise.instanceId
      })

      if (originalIndex !== -1) {
        // Die Übung aus der Liste entfernen (mit Toast)
        this.removeExercise(originalIndex, true)
      }

      // WICHTIG: Das Element sofort wieder aus der "unsichtbaren" Liste der Löschzone entfernen,
      // da wir es ja nicht wirklich "hinzufügen" wollen.
      event.target.removeChild(event.item)
    },
    async fetchExercises() {
      let exercisesData = this.exerciseList
      if (!exercisesData || exercisesData.length === 0) {
        const data = await api.fetchDevices()
        this.setDeviceList(data)
        exercisesData = data
      }
      this.exercises = exercisesData
      this.updateVisibleItems()
    },
    getImageForExercise(exercise) {
      if (exercise.picture) return this.getImageUrl(exercise.picture)
      if (exercise.manual && exercise.manual[0]?.picture) return this.getImageUrl(exercise.manual[0].picture)
      return "/img/einmalig/imageUploadPlaceholder.jpg"
    },
    getImageUrl(image) {
      if (!image) return ""
      return `/img/uebungen/${image.replace(/\.[^/.]+$/, "")}.webp`
    },
    startNewSplit() {
      this.addNewSplit = true
      this.$nextTick(() => this.$refs.newSplitInput.focus())
    },
    saveNewSplit() {
      if (!this.newSplitName.trim()) return
      this.$emit("save-split", this.newSplitName.trim())
      this.cancelNewSplit()
    },
    cancelNewSplit() {
      this.newSplitName = ""
      this.addNewSplit = false
    },
    edit(item, index) {
      this.selectedExerciseIndex = index
      this.selectedExercise = JSON.parse(JSON.stringify(item))
      this.editMode = true
    },
    cancelEdit() {
      this.editMode = false
      this.selectedExercise = null
      this.selectedExerciseIndex = null
    },
    saveExercise(configuredExercise) {
      this.$set(this.form.splits.workouts[this.selectedSplit].exercises, this.selectedExerciseIndex, configuredExercise)
      this.cancelEdit()
    },
    nextStep() {
      for (const workout of this.form.splits.workouts) {
        if (workout.exercises.length === 0) {
          this.$toast.error(`Bitte füge mindestens eine Übung zum Split "${workout.title}" hinzu.`)
          return
        }
        for (const exercise of workout.exercises) {
          if (exercise.isSuperset) {
            if (!exercise.exercises.every((ex) => (ex.sets && ex.sets.length > 0) || this.isDurationExercise(ex) || ex.isConfigured)) {
              this.$toast.error(`Bitte konfiguriere alle Übungen im Supersatz des Splits "${workout.title}".`)
              return
            }
            continue
          }
          if (exercise.title === "Senso Pro") {
            if (!exercise.isConfigured) {
              this.$toast.error(`Bitte konfiguriere die Geräteeinstellungen für "Senso Pro" im Split "${workout.title}".`)
              return
            }
            continue
          }
          if ((!exercise.sets || exercise.sets.length === 0) && !this.isDurationExercise(exercise)) {
            if (!exercise.warmup) {
              this.$toast.error(`Bitte füge Sätze zur Übung "${exercise.title}" im Split "${workout.title}" hinzu.`)
              return
            }
          }
        }
      }
      this.$emit("next")
    },
    updateHighlight(index) {
      this.$nextTick(() => {
        const btns = this.$el.querySelectorAll(".custom-btn")
        const highlight = this.$refs.highlight
        if (!btns.length || !highlight || !btns[index]) {
          if (highlight) highlight.style.width = "0px"
          return
        }
        const selectedBtn = btns[index]
        highlight.style.transition = "left 0.3s ease, width 0.3s ease"
        highlight.style.width = `${selectedBtn.offsetWidth}px`
        highlight.style.left = `${selectedBtn.offsetLeft}px`
      })
    },
  },
}
</script>
<style lang="scss" scoped>
/* KEYFRAME-ANIMATIONEN FÜR DYNAMISCHE EFFEKTE */
@keyframes pulse-glow {
  0%,
  100% {
    transform: scale(1);
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  50% {
    transform: scale(1.1);
    text-shadow: 0 0 25px rgba(255, 255, 255, 1);
  }
}

/* GRUNDKARTEN-STIL MIT VERBESSERTEM SCHATTEN FÜR MEHR TIEFE */
.glass-card {
  background: rgba(60, 60, 60, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  /* Tieferer, komplexerer Schatten für einen modernen Look */
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  border-radius: 16px !important; /* Einheitlicher Radius */
  transition: all 0.3s ease;
}

/* KARTE, DIE GERADE BEWEGT WIRD - HEBT SICH STARK AB */
.moving-card-clone {
  transform: scale(1.05); /* Hebt die Karte an */
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7) !important; /* Starker Schatten für "Schwebe"-Effekt */
}

/* HERVORHEBUNG FÜR SUPERSET-AUSWAHL - MEHR GLOW */
.exercise-card-dest.is-selected-for-superset {
  border-color: orange !important;
  /* Intensiverer Oranger Glow */
  box-shadow: 0 0 25px rgba(255, 165, 0, 0.75) !important;
}

/* SUPERSET-KARTE - DEZENTER DAUERHAFTER GLOW */
.superset-card-dest {
  border-radius: 12px !important;
  margin-bottom: 8px;
  position: relative;
  padding-top: 10px;
  border: 1px solid orange !important;
  /* Passender Oranger Schatten */
  box-shadow: 0 0 15px rgba(255, 165, 0, 0.5) !important;
}

/* ÜBUNGSKARTE IN DER ZIEL-LISTE */
.exercise-card-dest {
  border-radius: 12px !important;
  margin-bottom: 12px; /* Etwas mehr Abstand */
  min-height: 92px;
  position: relative;
  border: 2px solid transparent;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

/* BUTTON-SWITCHER MIT GLOW-EFFEKT */
.button-switcher {
  position: relative;
  width: 100%;
  overflow-x: auto;
}
.custom-toggle {
  background: transparent !important;
  position: relative;
  display: flex;
  width: fit-content;
}
.button-container {
  display: flex;
  flex-wrap: nowrap;
}
.custom-btn {
  border: 3px solid white;
  background-color: transparent !important;
  color: #d7d7d7;
  font-weight: bold;
  transition: color 0.3s;
  z-index: 2;
}
.highlight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  /* Stärkerer, lebendigerer Glow für den aktiven Tab */
  box-shadow: 0 0 20px rgba(0, 150, 63, 0.8), 0 0 10px rgba(0, 255, 100, 0.6) !important;
  background-color: var(--v-primary);
  border-radius: 8px;
  z-index: 1;
}

.custom-toggle--active {
  color: #fff !important;
  /* Text selbst bekommt einen leichten Schein */
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.4);
}

/* ----- NEUE "TIKTOK STYLE" DELETE ZONE ----- */

.delete-zone-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0; /* Stellt sicher, dass die Zone die volle Breite hat */
  z-index: 1000;
  pointer-events: none;
}

.delete-zone {
  /* Lebendiger Farbverlauf statt flacher Farbe */
  background: linear-gradient(to top, rgba(255, 0, 80, 0.95), rgba(180, 0, 50, 0.85));
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: white;
  text-align: center;
  /* Neon-Glow-Effekt am oberen Rand */
  box-shadow: 0 -10px 30px rgba(255, 0, 80, 0.7);
  border-top: 2px solid rgba(255, 150, 150, 0.8);
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}

.delete-drop-area {
  width: 100%;
  min-height: 120px; /* Mehr Platz zum Droppen */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

/* Visuelles Feedback, wenn ein Element über der Zone schwebt */
.delete-drop-area.sortable-drag .delete-content {
  transform: scale(1.1); /* Macht den Inhalt größer */
}
.delete-drop-area.sortable-drag .delete-content .v-icon {
  color: #ffdddd;
  animation-play-state: paused; /* Stoppt die normale Animation für eine gezielte Reaktion */
  transform: scale(1.2);
}

.delete-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* Elastischer Übergang */
}

.delete-content .v-icon {
  font-size: 48px !important; /* Größeres Icon */
  color: white;
  /* Pulsierende Glow-Animation auf dem Icon */
  animation: pulse-glow 2s infinite ease-in-out;
  margin-bottom: 8px;
  transition: transform 0.2s ease, color 0.2s ease;
}

.delete-content span {
  font-weight: 700; /* Fetter Text */
  font-size: 1rem;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.5); /* Bessere Lesbarkeit */
}

/* ----- ANDERE VERBESSERUNGEN ----- */

.d-flex.flex-column {
  height: 100%;
  max-height: calc(100vh - 200px);
}
.filter-section {
  display: flex;
  align-items: center;
}
.source-list-container {
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
}
.source-card-wrapper {
  padding-bottom: 12px;
}
.exercise-avatar {
  border-radius: 12px !important;
}
.exercise-content {
  flex-grow: 1;
  padding: 0 16px;
  min-width: 0;
}
.drag-handle {
  color: #aaa;
  cursor: grab;
}
.dropzone-wrapper {
  flex-grow: 1;
  position: relative;
  border: 2px dashed #444;
  overflow-y: auto;
  border-radius: 16px;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Leichter Glow, wenn eine Drag-Aktion aktiv ist */
.dropzone-wrapper.is-dragging-active {
  border-color: var(--v-primary);
  box-shadow: inset 0 0 15px rgba(0, 150, 63, 0.3);
}
.dropzone {
  min-height: 150px;
  height: 100%;
  overflow-y: auto;
  padding: 16px;
}
.empty-dropzone-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #777;
  font-weight: bold;
}
.new-split-wrapper {
  position: relative;
  overflow: hidden;
  height: 48px;
  width: 62px;
  transition: width 0.3s ease;
  display: inline-flex;
  align-items: center;
}
.new-split-wrapper.active {
  width: 250px;
}
.add-split-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 8px;
}
</style>
